import store from "@/store/index";
import router from "@/router/index";
import { StoreModule } from "@/store/types";
import { GlobalActions } from "@/store/modules/global/types";
import { NotificationService } from "@/services/notification_service";

export class AuthError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static logout(): void {
    store.dispatch(StoreModule.Global + GlobalActions.AddLoggedIn, false);
    store.dispatch(StoreModule.Global + GlobalActions.AddRole, null);
    store.dispatch(StoreModule.Global + GlobalActions.AddAuthToken, null);
    NotificationService.show(
      "Your session has expired. Redirecting to login...",
      "danger"
    );
    setTimeout(() => {
      window.location.replace("/login");
    }, 2000);
  }
}

export class PermissionsError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    NotificationService.show(statusCode + " : " + message, "danger");
  }
}

export class LoginError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    NotificationService.show(statusCode + " : " + message, "danger");
  }
}
export class GenericError extends Error {
  static popup(message: string) {
    NotificationService.show(message, "danger");
  }
}

export class APIError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    NotificationService.show(statusCode + " : " + message, "danger");
  }
}

export class NotFoundError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    NotificationService.show(statusCode + " : " + message, "danger");
  }
}

export class BadRequest extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    NotificationService.show(statusCode + " : " + message, "danger");
  }
}

export class ViewerError extends Error {
  static redirect(err?: string) {
    router.push("/error");
  }
}
